export enum PaymentMethodFlowActionType {
    plaid = 'plaid',
    none = 'none',
    three_d_secure = 'three_d_secure',
    wait = 'wait',
}